// extracted by mini-css-extract-plugin
module.exports = {"tilesContainer":"latest-post-module--tiles-container--2J70b","tiles":"latest-post-module--tiles--3ikxx"};